module.exports = __webpack_public_path__ + "608c315e813424c8951fd93e928b6005.svg";